import { Check } from "lucide-react";
import { SERVICES, FULL_SCOPE } from "@/data/site";

export default function Services() {
  return (
    <section id="services" className="bg-white text-[#0f172a] py-24 border-b border-slate-200">
      <div className="max-w-7xl mx-auto px-6">
        <div className="max-w-3xl mb-16">
          <span className="text-xs font-bold uppercase tracking-widest text-[#1e3a8a] block mb-2">Complete Civil &amp; Polishing Scope</span>
          <h2 className="display-font text-4xl sm:text-5xl uppercase tracking-tight text-[#0f172a]">
            Precision Marble &amp; Granite Services
          </h2>
          <p className="text-slate-600 mt-4 text-base">
            Executed with heavy-duty rotary diamond machines, imported Italian crystallization powders, and epoxy resin filling formulas.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {SERVICES.map((s, i) => (
            <div
              key={s.name}
              data-testid={`service-card-${i + 1}`}
              className="bg-[#f8fafc] p-6 border border-slate-200 rounded-lg hover:border-[#1e3a8a] transition-colors group"
            >
              <figure className="relative aspect-[16/10] rounded mb-5 overflow-hidden">
                <img
                  src={s.img}
                  alt={`${s.name} — ${s.desc}`}
                  className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <figcaption className="absolute bottom-4 left-4 text-[11px] uppercase tracking-wider font-bold text-slate-700 bg-white/90 px-2 py-1 rounded">
                  {s.tag}
                </figcaption>
              </figure>
              {s.extraImgs && (
                <div className="grid grid-cols-2 gap-2 mb-5 -mt-3">
                  {s.extraImgs.map((src, j) => (
                    <img
                      key={src}
                      src={src}
                      alt={`${s.name} work photo ${j + 2}`}
                      className="w-full aspect-square object-cover rounded border border-slate-200"
                      loading="lazy"
                    />
                  ))}
                </div>
              )}
              <h3 className="font-bold text-lg text-slate-900 mb-2">{s.name}</h3>
              <p className="text-xs text-slate-600 leading-relaxed mb-4">{s.desc}</p>
              <span className="text-xs font-bold text-[#1e3a8a] tracking-wider uppercase group-hover:underline">Spec: {s.spec}</span>
            </div>
          ))}
        </div>

        <div className="mt-12 bg-slate-900 rounded-lg p-8">
          <h3 className="text-xs font-bold uppercase tracking-widest text-blue-300 mb-5">Full Service Scope — 13 Specialisations</h3>
          <ul data-testid="full-scope-list" className="grid sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-3">
            {FULL_SCOPE.map((item) => (
              <li key={item} className="flex items-start gap-2.5 text-sm text-slate-200">
                <Check className="w-4 h-4 text-emerald-400 mt-0.5 shrink-0" aria-hidden="true" />
                {item}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
